import { useState } from 'react';

export const useActivityBulkModal = () => {
  const [page, setPage] = useState(1);
  const [opened, setOpened] = useState(false);

  const toggleModal = () => setOpened((prev) => !prev);

  return {
    page,
    setPage,
    opened,
    toggleOpen: toggleModal,
  };
};
